<template><div><h1>VUX Next 发布日志</h1>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 添加属性 type</li>
</ul>
<h2><a href="/zh-CN/components/swipeout.html">Swipeout</a></h2>
<ul><li>[feature] 添加属性 disabled</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX Next 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// next-193.vue?5808b084